import { createContext } from 'react';

const SalesOrderManagementContext = createContext({
  data: null,
  invalidate: () => { },
});

export default SalesOrderManagementContext;